import RelatedDocsPanel from "../../../../components/order/Change/RelatedDocsPanel";

function RenameConfirmationRelevantFiles({ data }) {
  return (
    <div className="mt-4">
      <RelatedDocsPanel
        data={data}
        title="Uploaded files"
        empty={false}
      />
    </div>
  );
}

export default RenameConfirmationRelevantFiles;
